var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Select } from '@folio/stripes/components';
import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { DateFormatType } from '../../../types';
export default function DatePartPicker(_a) {
    var prefix = _a.prefix;
    var intl = useIntl();
    return (React.createElement(Field, { name: "".concat(prefix, "format"), defaultValue: DateFormatType.YEAR_LONG }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { required: true, marginBottom0: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.token.currentDate.format" }), dataOptions: [
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.yearLong',
                }),
                value: DateFormatType.YEAR_LONG,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.yearShort',
                }),
                value: DateFormatType.YEAR_SHORT,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.dayOfYear',
                }),
                value: DateFormatType.DAY_OF_YEAR,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.month',
                }),
                value: DateFormatType.MONTH,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.date',
                }),
                value: DateFormatType.DATE,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.hour',
                }),
                value: DateFormatType.HOUR,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.minute',
                }),
                value: DateFormatType.MINUTE,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.second',
                }),
                value: DateFormatType.SECOND,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.quarter',
                }),
                value: DateFormatType.QUARTER,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.isoWeekNum',
                }),
                value: DateFormatType.WEEK_OF_YEAR_ISO,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.isoWeekYear',
                }),
                value: DateFormatType.WEEK_YEAR_ISO,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.YYYYMMDD',
                }),
                value: DateFormatType.YYYYMMDD,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.YYYY-MM-DD',
                }),
                value: DateFormatType.YYYY_MM_DD,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.MMDDYYYY',
                }),
                value: DateFormatType.MMDDYYYY,
            },
            {
                label: intl.formatMessage({
                    id: 'ui-plugin-bursar-export.bursarExports.token.currentDate.format.DDMMYYYY',
                }),
                value: DateFormatType.DDMMYYYY,
            },
        ] }))); }));
}
